import React, { useState, useEffect } from "react";

const questions = [
  {
    ulrikaQuestion: "Vad är ditt främsta mål just nu?",
    userAnswers: [
      "Gå ner i vikt snabbt och kickstarta",
      "Hitta balans och hållbara vanor",
      "Få mer energi och må bättre i vardagen",
    ],
    ulrikaInformationalText: "",
  },
  {
    ulrikaQuestion: "Hur mycket vill du gå ner i vikt?",
    userAnswers: [
      "Ca 5 kilo – vill se snabba resultat",
      "10–15 kilo – redo för en större förändring",
      "Mer än 15 kilo – jag vill ha en långsiktig plan",
    ],
    ulrikaInformationalText: "",
  },
  {
    ulrikaQuestion: "Hur ser din vardag ut?",
    userAnswers: [
      "Fullt upp – jag behöver enkla och snabba lösningar",
      "Jag gillar att laga mat och testa nya recept",
      "Jag vill ha tydliga scheman och struktur att följa",
    ],
    ulrikaInformationalText: "",
  },
  {
    ulrikaQuestion: "Hur viktigt är träning för dig i kursen?",
    userAnswers: [
      "Mycket viktigt – vill gärna kombinera kost med träning",
      "Lite grann – mest för att komma igång",
      "Fokus på kost – träning kan komma senare",
    ],
    ulrikaInformationalText: "",
  },
  {
    ulrikaQuestion: "Vad motiverar dig mest?",
    userAnswers: [
      "Snabba resultat som jag ser direkt på vågen",
      "Att bygga nya vanor steg för steg",
      "Att känna mig starkare, lättare och piggare",
    ],
    ulrikaInformationalText: "",
  },
];


const CourseSelector = ({ callbackFromCourseSelector }) => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState(
    () => JSON.parse(sessionStorage.getItem("courseSelections")) || []
  );
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isComplete, setIsComplete] = useState(false);

  const [loading, setLoading] = useState(false);
  const [recommendations, setRecommendations] = useState([]);

  useEffect(() => {
    sessionStorage.setItem("courseSelections", JSON.stringify(selectedAnswers));
  }, [selectedAnswers]);

  useEffect(() => {
    const storedRecommendations = sessionStorage.getItem("courseRecommendations");
    if (storedRecommendations) {
      setRecommendations(JSON.parse(storedRecommendations));
      setIsComplete(true);
    }
  }, []);
  

  useEffect(() => {
    if (isComplete) {
      const fetchRecommendations = async () => {
        setLoading(true);
        const storedSelections = JSON.parse(sessionStorage.getItem("courseSelections")) || [];
      
        try {
          const response = await fetch(
            "https://europe-central2-ulrikadavidsson-3d8f3.cloudfunctions.net/app/api/courses",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(storedSelections),
            }
          );
      
          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      
          const data = await response.json();
          sessionStorage.setItem("courseRecommendations", JSON.stringify(data)); // Store recommendations

          callbackFromCourseSelector(data);
          setRecommendations(data);
        } catch (error) {
          console.error("Error fetching recommendations:", error);
        } finally {
          setLoading(false);
        }
      };
      

      fetchRecommendations();
    }
  }, [isComplete]);

  const toggleAnswerSelection = (answer) => {
    setSelectedOptions((prev) =>
      prev.includes(answer) ? prev.filter((a) => a !== answer) : [...prev, answer]
    );
  };

  const handleNextQuestion = () => {
    if (selectedOptions.length === 0) return;

    const questionLetter = String.fromCharCode(65 + currentQuestionIndex);
    const selectedIndices = selectedOptions.map((answer) => {
      const answerIndex = questions[currentQuestionIndex].userAnswers.indexOf(answer) + 1;
      return `${questionLetter}${answerIndex}`;
    });

    const updatedSelections = [...selectedAnswers, ...selectedIndices];

    setSelectedAnswers(updatedSelections);
    sessionStorage.setItem("courseSelections", JSON.stringify(updatedSelections));

    setSelectedOptions([]);

    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
    } else {
      setIsComplete(true);
    }
  };

  const restartQuestions = () => {
    setCurrentQuestionIndex(0);
    setSelectedAnswers([]);
    setSelectedOptions([]);
    setIsComplete(false);
    setRecommendations([]);
    sessionStorage.removeItem("courseSelections");
  };

  if (isComplete) {
    if (loading) {
      return <span className="loader"></span>;
    }




    return (
      <>
      <button className="courseSelectorRestartRecommendations" onClick={restartQuestions}>
  Visa frågorna igen
</button>
<div className="kursvaljarerecommendationsWrapper">
{recommendations.map((course, index) => (
<a
  key={index}
  href={course.link}
  target="_top"
  className="kursvaljarerecommendationBoxLink"
  style={{ textDecoration: "none" }}
>
  <div
    className="kursvaljarerecommendationBox"
    style={{ backgroundImage: `url(${course.og_image_url})` }}
  >
    <div className="kursvaljarerecommendationBoxFooter">
      <span className="kursvaljarerecommendationText">{course.name}</span>
    </div>
  </div>
</a>
))}

</div>
</>
    );
  }

  const currentQuestion = questions[currentQuestionIndex];

  return (
    <div>
      <h2 className="courseSelectorQuestion">{currentQuestion.ulrikaQuestion}</h2>
      {currentQuestion.userAnswers.map((answer, index) => (
        <button
          className={`courseSelectorUserAnswers ${selectedOptions.includes(answer) ? "selected" : ""}`}
          key={index}
          onClick={() => toggleAnswerSelection(answer)}
        >
          <span className="answerText">{answer}</span>
          <span className={`courseSelectorCircle ${selectedOptions.includes(answer) ? "courseSelectorCircleChecked" : ""}`}>
            {selectedOptions.includes(answer) && "✔"}
          </span>
        </button>
      ))}
      <button
        className="courseSelectorNextButton"
        onClick={handleNextQuestion}
        disabled={selectedOptions.length === 0}
      >
        Nästa →
      </button>
      {currentQuestion.ulrikaInformationalText && (
        <p className="courseSelectorQuestion">{currentQuestion.ulrikaInformationalText}</p>
      )}
    </div>
  );
};

export default CourseSelector;
